import { Create } from 'react-admin';
import { VideoForm, } from './VideoForm';
import { getEmbedUrlAndDimensions } from '../../lib/media/videoFunctions';
import { fromGenericToUTC } from '../../lib/i18n/utils';

const enrichtWithEmbedData = (data: any) => {
  var embedData = getEmbedUrlAndDimensions({ url: data.videoUrl, nocookie: false, controls: false, modestBranding: true, loop: true });
  return { ...data, publishedAt: data.publishedAt ? fromGenericToUTC(data.publishedAt) : undefined, videoEmbedUrl: embedData?.url, videoWidth: embedData?.width, videoHeight: embedData?.height, videoThumbnailUrl: embedData?.thumbnail_url };
}

export const VideoCreate = (props: any) => {

  return (
    <Create transform={enrichtWithEmbedData} {...props} >
      <VideoForm />
    </Create>
  );
}
